(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('rfGlobalBadge', ['SharedAgendaBroadcast', 'SharedAgendaService', 'DayTaskBroadcast', '$rootScope', BadgeFn]);

    function BadgeFn(SharedAgendaBroadcast, SharedAgendaService, DayTaskBroadcast, $rootScope) {
        var directive = {
            restrict: 'E',
            scope: {
                type: '@' // type of item (daytasks, appointments etc)
            },
            link: link
        };
        return directive;

        function link(scope, element) {
            let listener = null;
            // listen on change of ringfoondaytasks
            if (scope.type === "ringfoonDaytasks")
            {
                setColor("ringfoonDaytasks");
                makeElement($rootScope.filteredDayTaskBadgeCount);
                listener = scope.$on(DayTaskBroadcast.DayTasksFiltered, function () {
                    setColor($rootScope.filteredDayTaskBadgeCount);
                    makeElement($rootScope.filteredDayTaskBadgeCount);
                });
            }else{
                // first style
                setColor(SharedAgendaService.data.badgeCounts[scope.type])
                // then make inner-element
                makeElement(SharedAgendaService.data.badgeCounts[scope.type]);
                // listen on change of agenda-change
                listener = scope.$on(SharedAgendaBroadcast.BadgeUpdate, function () {
                    setColor(SharedAgendaService.data.badgeCounts[scope.type]);
                    makeElement(SharedAgendaService.data.badgeCounts[scope.type]);
                });
            }

            // make new badge-element
            function setColor(numberOfItems) {
                if(!element.hasClass('badge')){
                    element.addClass('badge');
                }
                if (scope.type === 'todos' || scope.type === 'ringfoonDaytasks' || scope.type === 'programInfos') {
                    // set color to red if more than one item
                    if (numberOfItems !== 0)
                    {
                        element.removeClass("badge-default");
                        if (scope.type === 'programInfos') {
                            element.addClass('badge-primary');    
                        } else {
                            element.addClass('badge-danger');
                        }                    
                    }else{
                        element.removeClass("badge-danger");
                        element.addClass('badge-default');
                    }
                } else{
                    element.addClass('badge-default');
                }
            }

            // make new badge-element
            function makeElement(value) {
                element.empty();
                element.text(value);
            }

            // on destroy
            scope.$on("$destroy", function () {
                listener();
                listener = null;
            });

        } // link
    }

})();